import { InjectionToken } from '@angular/core';

export const INPUT_MAX_LENGTH = new InjectionToken<{}>('INPUT_MAX_LENGTH');
export const INPUT_ERROR_PROP_NAME = new InjectionToken<{}>('INPUT_ERROR_PROP_NAME');
export const INPUT_ERROR_MESSAGE = new InjectionToken<{}>('INPUT_ERROR_MESSAGE');
